export const _LOAD_MODEL_ = 'Load:LeadModel';
export const _SET_RESELLER_ = 'Update:Reseller';
export const _DELETE_LEAD_ = 'Delete:Lead';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _SAVE_LEAD_SUCCESS_ = 'Save:LeadSuccess';

export const MODEL = {
  city: null,
  name: null,
  role: null,
  email: null,
  phone: null,
  status: null,
  country: null,
  zipcode: null,
  contact_by: null,
  newsletter: null,
  reseller_id: null,
  visited_product: null,
};
